<template>
  <modal :show="show" footerClasses="d-none">
    <SlideXLeftTransition origin="left" group>
      <form v-if="'list' == activeView" key="list" @submit.prevent="handleSubmit">
        <TagsList
          ref="listRef"
          v-model="tags"
          @form:edit="() => handleSwitchView('form')"
          key="list"
        >
          <template #title-extra>
            <b-button
              @click="() => handleSwitchView('form')"
              variant="primary"
              size="sm"
              class="m-0 py-2 px-3 text-capitalize"
              >Add New</b-button
            >
          </template>

          <template v-if="1 < reportsAssignee.length" #option-extras="{ option }">
            <ul class="pl-4 ml-1 my-2 small">
              <li
                v-for="report in getReportsByTag(option.value)"
                :key="`report-${option.value}-${report.name}`"
                :class="{
                  'text-info': !report.tag_assigned,
                  'text-gray': report.tag_assigned,
                }"
              >
                <s v-if="report.tag_assigned">{{ report.name }}</s>
                <template v-else>{{ report.name }}</template>
              </li>
            </ul>
          </template>
        </TagsList>

        <div class="mt-4 d-flex justify-content-between">
          <base-button
            @click="() => $emit('update:show', false)"
            type="white"
            class="px-0 bg-transparent shadow-none"
            >Cancel</base-button
          >
          <base-button native-type="submit" type="primary" size="sm" class="py-2 px-3"
            >Save</base-button
          >
        </div>
      </form>

      <TagsForm
        v-else
        key="form"
        @form:cancel="() => handleSwitchView('list')"
        @form:success="() => handleSwitchView('list')"
      />
    </SlideXLeftTransition>

    <template #footer>
      <div class="sr-only"></div>
    </template>
  </modal>
</template>

<script>
import Vue from "vue";
import { defineComponent, computed, ref, watch } from "@vue/composition-api";
import { createVuexHelpers } from "vue2-helpers";
import { SlideXLeftTransition } from "vue2-transitions";

import { ReportsService } from "@services";

import TagsList from "@components/TagsList";
import TagsForm from "@components/TagsForm";

export default defineComponent({
  name: "TagsModal",
  components: {
    SlideXLeftTransition,
    TagsList,
    TagsForm,
  },
  emits: ["update:show"],
  props: {
    id: {
      type: [Number, Array],
      required: false,
    },
    show: Boolean,
  },
  setup(props, { emit }) {
    const { useGetters } = createVuexHelpers();

    const { reports } = useGetters(["reports"]);

    const listRef = ref();
    const activeView = ref("list");
    const tags = ref([]);

    const reportsAssignee = computed(() => {
      return reports.value.results.filter((item) => {
        if (Array.isArray(props.id)) {
          return props.id.includes(item.id);
        } else {
          return item.id == props.id;
        }
      });
    });

    const getReportsByTag = (tagId) => {
      return reportsAssignee.value.map((item) => {
        let tagAssigned = !!item.tags.length;

        if (item.tags.length)
          tagAssigned = 0 <= item.tags.findIndex((tag) => tag.id == tagId);

        return {
          name: item.name,
          tag_assigned: tagAssigned,
        };
      });
    };

    const handleSwitchView = (view) => {
      activeView.value = view;
    };

    const handleSubmit = async () => {
      const optionsList = listRef.value.optionsList.map((item) => item.value);

      for await (const report of reportsAssignee.value) {
        const reportTags = report.tags.map((item) => item.id);
        const tagsList = optionsList
          .filter((item) => {
            if (reportTags.includes(item) && tags.value.includes(item)) return false;

            return reportTags.includes(item) || tags.value.includes(item);
          })
          .map((item) => {
            let type = "add";

            if (reportTags.includes(item) && !tags.value.includes(item)) type = "remove";

            return {
              type: type,
              tag: item,
            };
          });

        await ReportsService.assignTags(report.id, tagsList);

        if (tagsList.length) {
          report.tags = listRef.value.optionsList
            .filter((item) => {
              const tag = tagsList.find((tagItem) => tagItem.tag == item.value);

              if (tag && "remove" == tag.type) {
                return false;
              } else if ("undefined" == typeof tag) {
                return !!report.tags.find((report) => report.id == item.value);
              }

              return true;
            })
            .map((item) => ({
              id: item.value,
              name: item.text,
            }));
        }
      }

      tags.value = [];

      emit("update:show", false);

      Vue.prototype.$toasted.show("Tags assigned successfully.");
    };

    watch(
      () => props.id,
      (newId) => {
        if (Array.isArray(newId))
          tags.value = reportsAssignee.value[0].tags.map((item) => item.id);
      }
    );

    return {
      listRef,
      activeView,
      tags,
      reportsAssignee,
      getReportsByTag,
      handleSwitchView,
      handleSubmit,
    };
  },
});
</script>
